import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SignIn } from "./page/authentication/signin";
import { ForgotPassword } from "./page/authentication/forgotpassword";
import { Verification } from "./page/authentication/verification";
import { ResetPassword } from "./page/authentication/resetpassword";
import { Dashboard } from "./page/dashboard";
import { Order } from "./page/order";
import { Inventory } from "./page/inventory";
import { Transaction } from "./page/transaction";
// import { Support } from "./page/support";
// import { Setting } from "./page/setting";
import { RouteProtector } from "./config/routeProtector";
import { AdminManagement } from "./page/adminmanagement";
import { AdminDetails } from "./page/adminmanagement/admindetails";
import { InventoryDetails } from "./page/inventory/inventorydetails";
import ScrollToTop from "./ScrollToTop";
import { OrderDetails } from "./page/order/orderdetails";
import { NotFoundError } from "./page/notfound";

function App() {
	return (
		<BrowserRouter>
			<ScrollToTop>
				<Routes>
					<Route path={"/"} element={<SignIn />} />
					<Route path={"/forgot-password"} element={<ForgotPassword />} />
					<Route path={"/auth-verification/:id"} element={<Verification />} />
					<Route path={"/reset-password/:id"} element={<ResetPassword />} />
					<Route element={<RouteProtector />}>
						<Route path={"/dashboard"} element={<Dashboard />} />
						<Route path={"/order"} element={<Order />} />
						<Route path={"/order/:id"} element={<OrderDetails />} />
						<Route path={"/inventory"} element={<Inventory />} />
						<Route path={"/inventory/:id"} element={<InventoryDetails />} />
						<Route path={"/transaction"} element={<Transaction />} />
						{/* <Route path={"/support"} element={<Support />} />
					        <Route path={"/setting"} element={<Setting />} /> */}
						<Route path={"/admin-management"} element={<AdminManagement />} />
						<Route path={"/admin-management/:id"} element={<AdminDetails />} />
						<Route path="*" element={<NotFoundError />} />
					</Route>
				</Routes>
			</ScrollToTop>
		</BrowserRouter>
	);
}

export default App;
